module.exports = __webpack_public_path__ + "static/media/arrow-triangle-fill-down.a808ed29.svg";